




































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Verify from '@/components/verify/Verify.vue';


@Component({
  components: {
    Verify,
  },
})
export default class LandingPageLeftSide extends Vue {
    public verify: boolean = false;
}
